import { IComboBox, IComboBoxOption, VirtualizedComboBox } from '@fluentui/react';
import React, { FormEvent, useState } from 'react';
import { ICompanyCreationRequestListPageState } from './CompanyCreationListPage';
import IDropdownOption from '../../utils/types/IDropdownOption';

interface IAcquistionProps {
  filterState: ICompanyCreationRequestListPageState;
  setFilterState: React.Dispatch<React.SetStateAction<ICompanyCreationRequestListPageState>>;
  acquisitionOptions: IDropdownOption[];
}

const AcquisitionFilter = ({
  filterState,
  setFilterState,
  acquisitionOptions,
}: IAcquistionProps): JSX.Element => {
  const [selectedKeys, setSelectedKeys] = useState<number[]>(filterState?.acquisitionIds);

  const onAcquisitionFilterChange = (
    event: FormEvent<IComboBox>,
    option?: IComboBoxOption,
  ): void => {
    if (option) {
      const currentSelectedKeys = option.selected
        ? [...selectedKeys, option.key as number]
        : [...selectedKeys].filter((key) => key !== option.key);
      setSelectedKeys(currentSelectedKeys);
      setFilterState({ ...filterState, acquisitionIds: currentSelectedKeys });
    }
  };

  const formattedAcquisitionOptions = (): IComboBoxOption[] => {
    const options: IComboBoxOption[] =
      acquisitionOptions
        ?.filter((acquisition: IDropdownOption) => acquisition.key !== undefined)
        .map((acquisition: IDropdownOption) => ({
          key: acquisition.key,
          text: acquisition.text?.trim() || '',
        }))
        .sort((a: IComboBoxOption, b: IComboBoxOption) => a.text.localeCompare(b.text)) || [];

    options.unshift({ key: -1, text: 'None' });
    return options;
  };

  return (
    <>
      <VirtualizedComboBox
        label="Acquisitions"
        placeholder="No Filter Selected"
        selectedKey={selectedKeys}
        allowFreeform
        autoComplete="on"
        options={formattedAcquisitionOptions()}
        onChange={onAcquisitionFilterChange}
        multiSelect
      />
    </>
  );
};

export default AcquisitionFilter;
